// angular
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../core/core.service';
// others
import { AppService } from '../../app.service';
import { AuthService } from '../../core/auth.service';
import { Router } from '@angular/router';
import { ProfileService } from './profile.service';
import { concatMap, from, tap } from 'rxjs';
import { MeComponent } from '../me.component';
import { KlenicoMeService } from '../me.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ProfileService]
})

export class ProfileComponent extends MeComponent implements OnInit, OnDestroy {
    url = 'profile';
    urlAPI = 'b2c-patients';
    patientId: number;
    data: any;
    profile: any;
    language = this.translate.currentLang;
    form: FormGroup;
    editting: boolean = false;
    submitted: boolean;
    hidePassword = true;
    contents = [];
    showSuccessPage = false;
    @Input() slug: string = '';
    colData = {
        left: [],
        right: []
    };
    svgIcons = {
        FAQ: '<svg width="80" height="80" viewBox="0 0 80 80" fill="none"><rect width="80" height="80" rx="40" fill="#FFFBC2"></rect><g clip-path="url(#clip0_3175_28974)"><path d="M55.7144 21.4286H24.2859C23.5281 21.4286 22.8014 21.7296 22.2655 22.2654C21.7297 22.8012 21.4287 23.528 21.4287 24.2857V48.5714C21.4287 49.3292 21.7297 50.0559 22.2655 50.5917C22.8014 51.1276 23.5281 51.4286 24.2859 51.4286H30.0001V58.5714L38.9144 51.4286H55.7144C56.4722 51.4286 57.1989 51.1276 57.7347 50.5917C58.2706 50.0559 58.5716 49.3292 58.5716 48.5714V24.2857C58.5716 23.528 58.2706 22.8012 57.7347 22.2654C57.1989 21.7296 56.4722 21.4286 55.7144 21.4286Z" stroke="#202A4D" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"></path><path d="M35.7144 32.8571C35.7144 32.0094 35.9657 31.1808 36.4366 30.4761C36.9075 29.7713 37.5769 29.222 38.36 28.8976C39.1431 28.5732 40.0048 28.4884 40.8362 28.6537C41.6675 28.8191 42.4312 29.2273 43.0305 29.8266C43.6299 30.426 44.0381 31.1896 44.2034 32.021C44.3688 32.8523 44.2839 33.714 43.9596 34.4972C43.6352 35.2803 43.0859 35.9496 42.3811 36.4205C41.6763 36.8914 40.8477 37.1428 40.0001 37.1428V38.5714" stroke="#202A4D" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"></path><path d="M40 42C39.8022 42 39.6089 42.0586 39.4444 42.1685C39.28 42.2784 39.1518 42.4346 39.0761 42.6173C39.0004 42.8 38.9806 43.0011 39.0192 43.1951C39.0578 43.3891 39.153 43.5673 39.2929 43.7071C39.4327 43.847 39.6109 43.9422 39.8049 43.9808C39.9989 44.0194 40.2 43.9996 40.3827 43.9239C40.5654 43.8482 40.7216 43.72 40.8315 43.5556C40.9414 43.3911 41 43.1978 41 43C40.9965 42.7359 40.8901 42.4835 40.7033 42.2967C40.5165 42.1099 40.2641 42.0035 40 42Z" fill="#202A4D"></path></g><defs><clipPath id="clip0_3175_28974"><rect width="40" height="40" fill="white" transform="translate(20 20)"></rect></clipPath></defs></svg>',
        PRIVACY: '<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '            <rect width="80" height="80" rx="40" fill="#FFFBC2"></rect>\n' +
            '            <path d="M41.58 59.79C40.885 60.0582 40.115 60.0582 39.42 59.79V59.79C33.9921 57.6617 29.3314 53.9472 26.0457 49.131C22.7599 44.3148 21.0016 38.6203 21 32.79V24C21 23.2044 21.3161 22.4413 21.8787 21.8787C22.4413 21.3161 23.2044 21 24 21H57C57.7957 21 58.5587 21.3161 59.1213 21.8787C59.6839 22.4413 60 23.2044 60 24V32.76C60.0044 38.5954 58.2489 44.2965 54.9628 49.1186C51.6767 53.9408 47.0127 57.6598 41.58 59.79V59.79Z"\n' +
            '                  stroke="#202A4D" stroke-width="1.65789" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
            '            <path d="M40.5 43.5C44.6421 43.5 48 40.1421 48 36C48 31.8579 44.6421 28.5 40.5 28.5C36.3579 28.5 33 31.8579 33 36C33 40.1421 36.3579 43.5 40.5 43.5Z"\n' +
            '                  stroke="#202A4D" stroke-width="1.65789" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
            '            <path d="M29.25 53.07C30.6576 51.4739 32.3888 50.1956 34.3284 49.32C36.2681 48.4444 38.3719 47.9916 40.5 47.9916C42.6281 47.9916 44.7319 48.4444 46.6716 49.32C48.6112 50.1956 50.3424 51.4739 51.75 53.07"\n' +
            '                  stroke="#202A4D" stroke-width="1.65789" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
            '        </svg>',

    };

    constructor(
        public appService: AppService,
        public translate: TranslateService,
        public coreService: CoreService,
        public router: Router,
        public profileService: ProfileService,
        public authService: AuthService,
        public meService: KlenicoMeService
    ) {
        super(appService, translate, coreService, router, profileService, authService);
    }

    ngOnInit() {
        this.appService.isLoading = true;
        let config = JSON.parse(this.appService.getMeClinicConfig());
        let steps = config?.profileCards;
        let i = 0;
        const user = this.authService.user;
        this.patientId = this.authService.patientId;
        if(!steps || !this.patientId || this.patientId == 0){
            this.router.navigate(['me/login']);
            return;
        }
        this.meService.isProfilePage = true;
        this.getProfileData();

        from(steps).pipe(
            tap(() => {
                this.appService.isLoading = true;
            }),
            concatMap(
                step => this.appService.getStoryBlokSlugByUuid(step)
            ),
        ).subscribe(response => {
                this.contents.push(response['story']);
                if (i % 2 === 0) {
                    this.colData.left.push(response['story']);
                } else {
                    this.colData.right.push(response['story']);
                }
                i++;
            },
            () => {
            },
            () => {
                this.appService.isLoading = false;
                this.data = this.contents;
                if (!this.data) {
                    this.showSuccessPage = true;
                }
            });
    }

    ngOnDestroy(){
        this.meService.isProfilePage = false;
    }

    getProfileData() {
        this.profileService.getProfile(this.patientId).subscribe(response => {
            this.profile = response;
            this.profile['id'] = this.patientId;
            this.languages = JSON.parse(localStorage.getItem('languages'));
            let form = {};
            this.formLoading = false;
        });
    }

    goToSR() {
        this.router.navigate(['me/self-evaluation']);
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            this.appService.isLoading = false;
        });
    }

    // user addition/update handler: send user info to DB
    submit(model: any, isValid: boolean, url?: string, isUpdated?: boolean): void {
        if (url == null) {
            url = this.urlAPI;
        }

        this.resetErrors();
        // this ensures validation messages will only be displayed when necessary
        this.formSubmitted = true;
        // only when the form is valid and its values have been changed
        if (isValid) {
            this.isLoading = true;

            this.meService.submit(url, this.params['id'], model).pipe(
                finalize(() => {
                    this.isLoading = false;
                }))
                .subscribe(
                    response => {
                        this.handleResponse(response);
                        // Set Profile view to updated data
                        const newProfile = model;
                        for (let column in newProfile) {
                            if (this.profile.hasOwnProperty(column)) {
                                this.profile[column] = newProfile[column];
                            }
                        }
                    },
                    error => {
                        this.isLoading = false;
                        this.errorMessage = this.appService.parseErrors(error);
                        this.errorData = error?.error?.data || '';
                    }
                );
        }
    }

    delete(model: any, isValid: boolean, url?: string): void {
        if (url == null) {
            url = this.urlAPI;
        }

        this.resetErrors();
        // this ensures validation messages will only be displayed when necessary
        this.formSubmitted = true;
        // only when the form is valid and its values have been changed
        if (isValid) {
            this.isLoading = true;

            this.profileService.patientId = this.params['id'];
            this.profileService.deleteProfile(url).pipe(
                finalize(() => {
                    this.isLoading = false;
                    return this.logout();
                }))
                .subscribe(
                    response => {
                        this.handleResponse(response);
                    },
                    error => {
                        this.isLoading = false;
                        this.errorMessage = this.appService.parseErrors(error);
                        this.errorData = error?.error?.data || '';
                    }
                );
        }
    }

    logout() {
        if (this.authService.isLoggedIn) {
            this.authService.logout();
            this.router.navigate(['me/login'], {
                queryParams: {
                    infoMessage: 'Your session has expired due to inactivity.'
                }
            });
        }
        localStorage.removeItem('active_time');
    }
}
